<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { ADDON_GROUP } from '@/common/constants';

export default {
  name: 'ZoomClipsAddon',
  mixins: [base, planCommon,addonCustomSelect],
  group(){
    return [ADDON_GROUP.WIN_BACK];
  }
};
</script>
